import { searchConsultContent } from "$lib/models/search/searchConsultContent"

/**@type {any}*/
let pagesRelated = [];

/**@param {string}findText */
export const findInSiteMap = (findText) => {
   pagesRelated = []
   let convertArr = findText.replaceAll('-', ' ').split(' ');
   searchConsultContent.map(related => {
      related.keywords.map(keyword => {
         if (convertArr.includes(String(keyword)) && !pagesRelated.includes(related.related)) {
            pagesRelated.push(related.related);
         }
      })
   })
   return pagesRelated;
}
